module.exports = __webpack_public_path__ + "static/media/iconcustomizable.b7631dca.svg";